import Image from "next/image";

type SquareImageProps = React.ComponentProps<typeof Image> & {
  imageClassName?: string;
};

export default function SquareImage({
  className,
  imageClassName,
  unoptimized = true,
  ...props
}: SquareImageProps) {
  return (
    <div className={`size-8 aspect-square relative ${className ?? ""}`}>
      <Image
        fill
        className={`object-cover ${imageClassName ?? ""}`}
        unoptimized={unoptimized}
        {...props}
      />
    </div>
  );
}
